// Google Places API utility functions
let placesService: google.maps.places.AutocompleteService | null = null;
// Removed session token variable

// Initialize the Google Places API
export const initGooglePlacesApi = (): Promise<void> => {
  return new Promise((resolve, reject) => {
    // Check if the API is already loaded
    if (window.google && window.google.maps && window.google.maps.places) {
      try {
        placesService = new google.maps.places.AutocompleteService();
        // Removed session token initialization
        resolve();
      } catch (error) {
        console.error('Error initializing Google Places services:', error);
        reject(error);
      }
      return;
    }

    // Create a global callback function
    window.initGooglePlacesCallback = () => {
      try {
        placesService = new google.maps.places.AutocompleteService();
        // Removed session token initialization
        resolve();
      } catch (error) {
        console.error('Error in Google Places API callback:', error);
        reject(error);
      }
    };

    // Handle script load error
    const handleScriptError = () => {
      console.error('Google Places API failed to load');
      reject(new Error('Google Places API failed to load'));
    };

    // Check if the script is already in the document
    const existingScript = document.getElementById('google-places-script');
    if (existingScript) {
      existingScript.addEventListener('error', handleScriptError);
      return;
    }

    // Create and append the script
    const script = document.createElement('script');
    script.id = 'google-places-script';
    script.type = 'text/javascript';
    script.src = `https://maps.googleapis.com/maps/api/js?key=${process.env.REACT_APP_GOOGLE_MAPS_API_KEY}&libraries=places&callback=initGooglePlacesCallback`;
    script.async = true;
    script.defer = true;
    script.onerror = handleScriptError;
    
    document.head.appendChild(script);
  });
};

// Get place predictions based on input
export const getPlacePredictions = async (
  input: string,
  types: string[] = ['(cities)']
): Promise<google.maps.places.AutocompletePrediction[]> => {
  if (!placesService) {
    try {
      await initGooglePlacesApi();
    } catch (error) {
      console.error('Failed to initialize Google Places API:', error);
      return [];
    }
  }

  if (!input.trim()) {
    return [];
  }

  // Removed session token validation code

  try {
    const response = await new Promise<google.maps.places.AutocompletePrediction[]>(
      (resolve, reject) => {
        // Create request object with all parameters
        const request: google.maps.places.AutocompletionRequest = {
          input,
          types,
          componentRestrictions: { country: 'in' }
        };
        
        // Removed session token code

        placesService!.getPlacePredictions(
          request,
          (predictions, status) => {
            if (status !== google.maps.places.PlacesServiceStatus.OK || !predictions) {
              resolve([]);
              return;
            }
            resolve(predictions);
          }
        );
      }
    );

    return response;
  } catch (error) {
    console.error('Error getting place predictions:', error);
    return [];
  }
};

// This function is kept as a no-op to avoid breaking existing code that calls it
export const resetSessionToken = () => {
  // No-op function
};

// Add TypeScript declarations for the Google Maps API callback
declare global {
  interface Window {
    google: typeof google;
    initGooglePlacesCallback: () => void;
  }
}
